module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "thehistoryof38"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("As Russia expanded its influence to Ukraine, the Hetman (Cossack) state developed its own rank system. The Cossack state was dominated by the Cossack "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("starshynas")]), _vm._v(", a general title applied to people of authority in the Ukrainian Cossack Regiments and the administration of the Hetman state (1648-1781). In order to preserve its autonomy from Russia, the Cossack "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("starshynas")]), _vm._v(" wanted Moscow to recognize Cossack titles and offices. In 1756, Hetman Kiril Razumovsky established a Ukrainian table of ranks consisting of 12 classes, excluding the two highest positions: the hetman and acting hetman. This system operated until 1784, when all Ukrainian titles were officially prohibited and Ukrainian nobles were encouraged to enter Russian service. When the Russian judicial system was introduced in 1796, the Ukrainian administrative positions were redefined according to the Table of Ranks (and are reproduced on the facing page)."), _c('span', {
    staticClass: "font01"
  }, [_c('sup', [_c('span', {
    attrs: {
      "href": "#/therussian_endnotes#thent155",
      "id": "theft155",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("155")])])])]), _vm._v(" "), _c('h2', {
    staticClass: "head"
  }, [_vm._v("1798-1800")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Emperor Paul made considerable changes to the Table of Ranks, hoping to simplify the promotion system and purge the military of its excessive number of officers. The Guard ranks remained two classes higher than an equivalent rank in other branches of the military, but the artillery and engineering ranks matched the infantry classes. Paul I also made an important change in the regimental structure, introducing the chef ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("shef")]), _vm._v(", colonel proprietor) of the regiment. Chef became a senior officer in the regiment and was responsible for maintenance and service of the unit. The dual command of regiments occurred with chefs and regimental commanders having similar authority. The regimental commander gradually became the second senior officer in the unit. He was to comply with the chef’s orders and only assumed full command in the chef’s absence.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c714614","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/therussian_thehistoryof38.vue
// module id = 207
// module chunks = 0